import ExcelJS from 'exceljs'
import {InspectionReportBase} from './type'

export const generateInspectionWorksheet = (
  workbook: ExcelJS.Workbook,
  data: any[],
  titleMap: Record<string, string>,
  heading?: string
): ExcelJS.Worksheet => {
  const worksheet = workbook.addWorksheet('Sheet1')
  const titles = Object.values(titleMap)
  const keys = Object.keys(titleMap)

  // 1. Optional heading
  if (heading) {
    worksheet.mergeCells(1, 1, 1, titles.length)
    const headingCell = worksheet.getCell('A1')
    headingCell.value = heading
    headingCell.font = {size: 14, bold: true, color: {argb: 'FFFF0000'}}
    headingCell.alignment = {horizontal: 'center', vertical: 'middle'}
    worksheet.getRow(1).height = 36

    // One empty row below heading
    worksheet.mergeCells(2, 1, 2, titles.length)
  }

  // 2. Header row
  const headerRowIndex = heading ? 3 : 1
  worksheet.insertRow(headerRowIndex, titles)
  const headerRow = worksheet.getRow(headerRowIndex)
  headerRow.font = {bold: true, size: 12}
  headerRow.alignment = {horizontal: 'center', vertical: 'middle'}
  headerRow.height = 24

  // 3. Data rows
  data.forEach((row) => {
    const rowData = keys.map((key) => {
      const combinedKeys = ['security_name', 'team_leader_name', 'driver_name', 'conductor_name']

      if (combinedKeys.includes(key)) {
        const date = row.team_leader_date
        const name = row[key] || ''
        if (!date) return name

        return `Inspected by ${name} at ${row.conductor_date}`
      }
      return row[key]
    })
    worksheet.addRow(rowData)
    worksheet.lastRow?.eachCell((cell) => (cell.font = {size: 14}))
  })

  return worksheet
}
